module.exports = __webpack_public_path__ + "img/Lucky5_pdf.4b8aa350.png";